import { api } from 'api/client';
import { API_ENDPOINTS } from 'config/api.config';
import { Campaign } from 'types/push.types';
import {
  GlobalCampaignCreateRequest,
  GlobalCampaignUpdateRequest,
  GlobalCampaignsListResponse,
} from 'types/global_campaigns.types';
import { SuccessResponse } from 'types/api.types';

export const globalCampaignsApi = {
  list: async (): Promise<GlobalCampaignsListResponse> => {
    const response = await api.get<GlobalCampaignsListResponse>(
      API_ENDPOINTS.globalCampaigns.list,
    );
    return response.data;
  },

  get: async (id: number): Promise<Campaign> => {
    const response = await api.get<Campaign>(
      API_ENDPOINTS.globalCampaigns.get(id),
    );
    return response.data;
  },

  create: async (
    data: GlobalCampaignCreateRequest,
  ): Promise<SuccessResponse & { campaign: Campaign }> => {
    const response = await api.post<SuccessResponse & { campaign: Campaign }>(
      API_ENDPOINTS.globalCampaigns.create,
      data,
    );
    return response.data;
  },

  update: async (
    id: number,
    data: GlobalCampaignUpdateRequest,
  ): Promise<SuccessResponse & { campaign: Campaign }> => {
    const response = await api.put<SuccessResponse & { campaign: Campaign }>(
      API_ENDPOINTS.globalCampaigns.update(id),
      data,
    );
    return response.data;
  },

  delete: async (id: number): Promise<SuccessResponse> => {
    const response = await api.delete<SuccessResponse>(
      API_ENDPOINTS.globalCampaigns.delete(id),
    );
    return response.data;
  },
};